/*global WebdavController, ViewController, WebView, moment*/
var docAttachPopupController = new ViewController(
    {
        directory: "views/attach",
        name: "docAttachPopup",
        route: "doc-attach-popup",
        openInPopup: true,
        noTitle: false,
        popup: {
            title: WebView.tr("attach.title")+' <button type="button" class="ml-3 btn btn-small btn-primary doc-attach-bt-upload"><i class="fas fa-file-upload"></i> <span>'+WebView.tr("attach.uploadFile")+'</span></button>',
            //size can by small, medium, large and wide
            size: "wide"
        }
    }
);

//handle the opening parameters
docAttachPopupController.prepareDataOnEnter = function(data, callback){
    //receive an id, read the record from database
    var search = { res_model: data.model, res_id: data.id||0 };
    if(data.field){
        search.res_field = data.field ;
    }

    let searchAttach = {
        iz_doc_link: { search: search, joinFetch: [
            { otherTable : "iz_doc", thisField: "doc_id", otherField: "id", flatten: true, joins: [
                {otherTable: "ir_attachment", name:"attach", thisField: "id", otherField: "res_id", joinSearch: {res_model : "iz.doc"}},
                { otherTable: "iz_doc_iz_doc_tag_rel", name: "tags", type: "2many", joins: [
                    { otherTable: "iz_doc_tag", flatten: true}
                ]},
            ]}
        ]},
        record: {
            table: data.model.replace(/\./g, "_"),
            searchFirst: { id: data.id }
        }
    };
    this.api.db.multiread(searchAttach, function(err, reads){
        if(err){ return callback(err) ;}

        var strProtocolList = localStorage.getItem("iz-protocol-list");
        var protocolList = [];
        if(strProtocolList && strProtocolList != ""){ //may be change to undefined
            try{
                protocolList = JSON.parse(strProtocolList);
            }catch(err){
                console.log("Should not happens : locale storage protocol list has wrong format") ;
            }
        }
        const docLinks = reads.iz_doc_link;
        docLinks.forEach(link => {
            if(link.attach){
                link.attach.hasProtocolOpen = protocolList.owopen;
                link.attach.hasProtocolOffline = protocolList.owoffline;
            }
        });

        callback(null,{
            record: reads.record,
            id: data.id,
            model: data.model,
            field: data.field,
            attachs: reads.iz_doc_link
        }) ;
    }) ;
} ;

docAttachPopupController.onDocSelect = function(ev){
    var doc = ev.data ;
    if(!doc.attach){ return WebView.info("Missing binary file"); }
    this.view.longTask(function(done){
        if (doc.attach) {
            this.preparePdfUrl(doc.attach, function(err){
                if(err){ return done(err) ;}
                this.data.doc = doc ;
                this.view.render() ;
                done() ;
            }.bind(this)) ;
        }else{
          done();
        }
    }.bind(this)) ;
} ;

docAttachPopupController.showDocument = function(doc, done){
    this.preparePdfUrl(doc.attach, function(err){
        if(err){ return done(err) ;}
        this.data.doc = null;
        this.view.render() ;
        this.data.doc = doc ;
        this.view.render() ;
        done() ;
    }.bind(this)) ;
} ;

docAttachPopupController.onDownload = function(ev){
    var doc = ev.data.data ;
    this.view.longTask(function(done){
        if (doc.attach) {
            this.api.readBinary.download(doc.attach, doc.attach.datas_fname, function(err){
                if(err){ return done(err) ;}
                done() ;
            }.bind(this)) ;
        }else{
          done() ;
        }
    }.bind(this)) ;
} ;

docAttachPopupController.onDelete = function(ev){
    var doc = ev.data.data ;
    WebView.confirm(WebView.tr("form.confirmDelete"), function(yes){
        if(yes){
            this.view.longTask(function(done){
                let search = {};
                search = {doc_id: doc.id};
                let attachId = null;
                if (doc.attach && doc.attach.id) {
                    attachId = doc.attach.id;
                }
                this.api.db.iz_doc_link.search(search, function(err, links){
                    if(err){ return done(err) ;}
                    var records = [] ;
                    if(links.length<=1){
                        records = [{
                            table: "iz_doc_link",
                            action: "removeWhere",
                            record: {
                                doc_id: doc.doc_id
                            }
                        },
                        {
                            table: "iz_doc",
                            action: "remove",
                            record: {
                                id: doc.doc_id
                            }
                        }];
                        if (attachId) {
                            records.push({
                                table: "ir_attachment",
                                action: "remove",
                                record: {
                                    id: attachId
                                }
                            });
                       }
                    }else{
                        records = [{
                            table: "iz_doc_link",
                            action: "removeWhere",
                            record: {
                                res_model: doc.res_model, 
                                res_id: doc.res_id
                            }
                        }] ;
                    }
                    this.api.db.transactionalChanges(records, function(err){
                        if(err){ return done(err) ;}
                        this.refresh(done) ;
                    }.bind(this)) ;
                }.bind(this))  ;
            }.bind(this)) ;
        }
    }.bind(this)) ;
} ;
docAttachPopupController.onModify = function(ev){
    var doc = ev.data.data ;
    doc.tag_ids = doc.tags.map(function(t){ return t.id ;}) ;
    this.onOpenUpload({data : doc}) ;
} ;

docAttachPopupController.onOpenUpload = function(ev){
    var data = ev.data||{};
    if(ev.data && ev.data.file){
        data.name = ev.data.file.name ;
        var indexDot = data.name.lastIndexOf(".") ;
        if(indexDot !== -1){
            data.name = data.name.substring(0, indexDot) ;
        }
        data.customFile = ev.data.file ;
    }
    data.attachMode = true ;
    var v = new WebView("modules/doc/views/attach",  "docAttachUpload") ;

    v.on("cancel", function(){ v.close() ;}) ;

    
    v.openInPopup({
        size: "wide",
        closeWithEsc: false,
        closeByClickOutside: false,
    },function(){
        v.render({docs : [data]}) ;
    });
    v.on("validate", function(){
        v.checkForm(function(err, formOk){
            if(err || !formOk){
                return;
            }
    
            v.updateData() ;

            var file = data.file ;

            var records = [] ;

            let docRecord = {
                id: data.doc_id,
                usage: "attach",
                name: data.name,
                description: data.description,
                last_workflow_comment: data.last_workflow_comment
            } ;

            if(this.data.record){
                if(this.data.record.company_id){
                    docRecord.company_id = this.data.record.company_id ;
                }
                if(this.data.record.iz_estab_id){
                    docRecord.iz_estab_id = this.data.record.iz_estab_id ;
                }
                if(this.data.record.estab_id){
                    docRecord.iz_estab_id = this.data.record.estab_id ;
                }
                if(this.data.record.agency_id){
                    docRecord.iz_agency_id = this.data.record.agency_id ;
                }
            }

            records.push({
                table: "iz_doc",
                record: docRecord
            }) ;

            records.push({
                table: "iz_doc_link",
                action: "insertOrUpdate",
                conditions: { 
                    doc_id: "${iz_doc.id}",
                    res_id: this.data.id,
                    res_model: this.data.model,
                    res_field: this.data.field
                },
                record: {
                    doc_id: "${iz_doc.id}",
                    res_id: this.data.id,
                    res_model: this.data.model,
                    res_field: this.data.field
                }
            });

            if (data.attach && data.attach.id && file) {
                records.push({
                    table: "ir_attachment",
                    action: "removeWhere",
                    record: {
                        id: data.attach.id
                    }
                });
            }

            if(data.id){
                records.push({
                    table: "iz_doc_iz_doc_tag_rel",
                    action: "removeWhere",
                    record: {
                        iz_doc_id: data.id
                    }
                }) ;
            }
        
            if(data.tag_ids){
                records.push({
                    table: "iz_doc_iz_doc_tag_rel",
                    action: "removeWhere",
                    record: {
                        iz_doc_id: "${iz_doc.id}"
                    }                    
                });
                data.tag_ids.forEach(function(tagId){
                    records.push({
                        table: "iz_doc_iz_doc_tag_rel",
                        action: "insert",
                        record: {
                            iz_doc_id: "${iz_doc.id}",
                            iz_doc_tag_id: tagId
                        }
                    }) ;
                }) ;
            } else {
                records.push({
                    table: "iz_doc_iz_doc_tag_rel",
                    action: "removeWhere",
                    record: {
                        iz_doc_id: "${iz_doc.id}"
                    }                    
                });
            }

            this.view.longTask(function(done){
                this.api.db.transactionalChanges(records, function(err, results){
                    if(err){ return done(err) ;}

                    

                    if(!file){
                        this.refresh(function(err){
                            if(err){ return done(err) ;}
                            this.onDocSelect({data: data}) ;
                            v.close() ;
                            done() ;
                        }.bind(this));
                    }else{
                        var binaryRecord = {
                            res_model: "iz.doc", 
                            mimetype: file.type,
                            datas_fname : file.name,
                            name: "template",
                            res_name: data.name,
                            res_field: data.field
                        };
        
                        results.forEach(function(r){
                            if(r.table === "iz_doc"){
                                binaryRecord.res_id = r.record.id ;
                            }
                        }) ;

                        this.api.api.saveBinary(
                            file,
                            binaryRecord, function(err){
                            if(err){ return done(err) ;}
                            this.refresh(function(err){
                                if(err){ return done(err) ;}
                                var doc = null;
                                this.data.attachs.some(function(a){
                                    if(a.id === binaryRecord.res_id){
                                        doc = a ;
                                        return true ;
                                    }
                                }) ;
                                if(doc){
                                    this.onDocSelect({data: doc}) ;
                                }
                                v.close() ;
                                done() ;
                            }.bind(this)) ;
                        }.bind(this)) ;
                    }
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

WebdavController.call(docAttachPopupController) ;
docAttachPopupController.onOpenWebdav = function() {
    if(this.data && this.data.doc) {
        this.view.longTask(function(done){
            this.openWebdav("iz.doc", this.data.doc.doc_id, done) ;
        }.bind(this)) ;
    }
} ;

docAttachPopupController.on("enter", function(){
    this.notificationListener() ;
}.bind(docAttachPopupController)) ;

docAttachPopupController._socketSaveWebdavRegistered = false;
docAttachPopupController.notificationListener = function(){
    if(this._socketSaveWebdavRegistered){ return; }
    this._socketSaveWebdavRegistered = true;
    this.api.socket.on('webdav-write-finished',  function(ev){
        if(ev.model === "iz.doc"){
            var docId = ev.id;
            if(docAttachPopupController.data && docAttachPopupController.data.doc && 
                docAttachPopupController.data.doc.doc_id == docId){
                docAttachPopupController.showDocument(docAttachPopupController.data.doc, function(err){
                    if(err){ console.log(err) ;}
                }) ;
            }
        }
    }.bind(this));
    this.api.socket.on('doc-pdf-finished',  function(ev){
        if(ev.model === "iz.doc"){
            var docId = ev.id ;
            if(docAttachPopupController.data && docAttachPopupController.data.doc && 
                docAttachPopupController.data.doc.doc_id == docId){
                docAttachPopupController.showDocument(docAttachPopupController.data.doc, function(err){
                    if(err){ console.log(err) ;}
                }) ;
            }
        }
    }.bind(this));
} ;




module.exports = docAttachPopupController ;